import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchCurrentUser } from '../api/auth.api';
import { useSession } from './useSession';
import { queryKeys } from '@/shared/lib/queryKeys';
import type { CurrentUser } from '@/shared/types/domain';

/**
 * Pessoa + papéis + escopo de quem está logado (ADR-001). `null` quando há
 * sessão de auth mas nenhum vínculo vigente — trate como "sem acesso"
 * (US-04), nunca como "ainda carregando".
 */
export function useCurrentUser(): UseQueryResult<CurrentUser | null> {
  const { session, isLoading: isSessionLoading } = useSession();

  return useQuery({
    queryKey: queryKeys.me,
    queryFn: fetchCurrentUser,
    enabled: !isSessionLoading && session !== null,
    // Vínculo pode ser encerrado a qualquer momento por outra pessoa (RNF-S04)
    // — não vale a pena confiar em cache por muito tempo.
    staleTime: 60_000,
  });
}
